/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_alarm: 'alarmStatus/set_alarm',
}

// count state 必須是 Object
const state = {
    alarm: {
        status: false,
        title: null,
        description: null,
        closeBtn: null,
        count: null,
        type: 'error'
    }
    
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_ALARM: (state) => {
        return state.alarm
    },
    
    
}

// actions 也是以 Object 形式建構。
const actions = {
    setAlarmStatus ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_alarm, data)
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_alarm](state, data){
        state.alarm = data
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/global/alarmStatus.js